import { useApiClient } from '@m43/core';
import { DexMessagesoutgoingResource } from '@mark43/dex-api';
import { useMutation, useQuery } from '@tanstack/react-query';

export interface UseMaLeapsPasswordReturn {
    doesHavePassword: boolean;
    setPassword: (password: string) => Promise<boolean | undefined>;
    isSettingPassword: boolean;
    errorSettingPassword: boolean;
}

export function useDexPasswordApi(): UseMaLeapsPasswordReturn {
    const apiClient = useApiClient();

    const passwordQuery = useQuery(['dex-password'], () => {
        return apiClient.request<DexMessagesoutgoingResource.GetDexPasswordExistsForUser>({
            service: 'DEX',
            method: 'GET',
            url: `dex_messages/outgoing/password_exists_for_user`,
        });
    });

    const passwordMutation = useMutation(async ({ password }: { password: string }) => {
        const r = await apiClient.request<DexMessagesoutgoingResource.SetDexPassword>({
            service: 'DEX',
            method: 'POST',
            url: `dex_messages/outgoing/password`,
            data: password,
            headers: {
                'content-type': 'application/json',
            },
        });
        void passwordQuery.refetch();
        return r.data.data;
    });

    return {
        doesHavePassword: passwordQuery.isLoading ? true : !!passwordQuery?.data?.data?.data,

        setPassword: (password) => passwordMutation.mutateAsync({ password }),
        isSettingPassword: passwordMutation.isLoading,
        errorSettingPassword: !!passwordMutation.error,
    };
}
